import { metaKey } from '~/scripts/utils';

export default async ({ $api, $honeybadgerGeneric, $deserialize, error, route, store }) => {
  await $api('media/blog/categories').then(r => store.commit('blog/setCategories', r));
  const category = route.params.category;
  if (category && !store.getters['blog/getCategories'].map(c => c.title).includes(category)) {
    return error({ statusCode: 404, message: store.$i18n.t('errors.categoryNotFound', [category]) });
  }
  const limit = metaKey(route, 'perPage');
  const author = route.params.author;
  const isProviderPage = metaKey(route, 'isProviderPage');
  const provider = store.getters['providers/get'];
  let tag;
  const page = route.query.page;
  const newMeta = { ...route.meta[0] };
  if (isProviderPage && provider && provider.name) {
    tag = provider.name;
  } else if (!author) {
    tag = route.params.tag;
    newMeta.breadcrumbs = buildBreadcrumbs(category, tag);
  }

  await $api('media/blog/articles', { author, category, limit, page, tag }).catch((e) => {
    console.error('Articles Error', e);
    $honeybadgerGeneric.notify(e, {
      name: 'Articles',
      context: {
        source: 'articles.js',
        error: e
      }
    });
  }).then(r => {
    if (r && r.length > 0) {
      store.commit('blog/setList', r);
    }
    if (author) {
      const authorInfo = $deserialize(store.getters['blog/getMeta'].author);
      store.commit('blog/setAuthor', authorInfo);
      newMeta.disableJumbotron = true;
      newMeta.metaTagOptions = { title: authorInfo.fullname };
    }
    if (category) {
      newMeta.jumbotronScope = `blog.${category}`;
    }
    route.meta[0] = newMeta;
  });
};

const buildBreadcrumbs = (category, tag) => {
  const breadcrumbs = [['i18n/home', '/']];
  if (category) {
    breadcrumbs.push(['i18n/blog', '/blog/']);
    breadcrumbs.push(`i18n/articleCategories.${category}`);
  } else if (tag) {
    breadcrumbs.push(['i18n/blog', '/blog/']);
    breadcrumbs.push(tag);
  } else {
    breadcrumbs.push('i18n/blog');
  }
  return breadcrumbs;
};
